/**
 * @description export all menu options
 */
export const menuItems = [
  {
    id: 'analytics',
    name: 'header.sidebar.analytics.index',
    url: '/analytics',
  },
  {
    id: 'analytics-o2o',
    name: 'header.sidebar.analytics.analytics-o2o',
    url: '/analytics/o2o',
  },
  {
    id: 'analytics-stores',
    name: 'header.sidebar.analytics.analytics-stores',
    url: '/analytics/stores',
  },
  {
    id: 'analytics-products',
    name: 'header.sidebar.analytics.analytics-products',
    url: '/analytics/products',
  },
  {
    id: 'performance-audiences',
    name: 'header.sidebar.performance-audiences',
    url: '/campaigns',
  },
  {
    id: 'welcome',
    name: 'header.sidebar.welcome',
    url: '/',
  },
  {
    id: 'oto-academy',
    name: 'header.sidebar.oto-academy',
    url: '/oto-academy',
  },
  {
    id: 'integrations',
    name: 'header.sidebar.integrations',
    url: '/connect',
  },
  {
    id: 'connect-import',
    name: 'header.sidebar.connect-import',
    url: '/connect/import',
  },
  {
    id: 'connect-export',
    name: 'header.sidebar.connect-export',
    url: '/connect/export',
  },
  {
    id: 'connect-raw-data-access',
    name: 'header.sidebar.connect-raw-data-access',
    url: '/connect/raw-data-access',
  },
  {
    id: 'connect-data-ingestion-history',
    name: 'header.sidebar.connect-data-ingestion-history',
    url: '/connect/data-ingestion-history',
  },
  {
    id: 'connect-data-inconsistency',
    name: 'header.sidebar.connect-data-inconsistency',
    url: '/connect/data-inconsistency',
  },
  {
    id: 'connect-tags',
    name: 'header.sidebar.connect-tags',
    url: '/connect/connect-tags',
  },
  {
    id: 'cashback',
    name: 'header.sidebar.cashback',
    url: '/cashback',
  },
  {
    id: 'cashback-cashback',
    name: 'header.sidebar.cashback-cashback',
    url: '/cashback/cashback',
  },
  {
    id: 'cashback-report',
    name: 'header.sidebar.cashback-report',
    url: '/cashback/cashback-report',
  },
  {
    id: 'store',
    name: 'header.sidebar.store',
    url: '/store',
  },
  {
    id: 'store-management-sellers',
    name: 'header.sidebar.store-management-sellers',
    url: '/store/sellers',
  },
  {
    id: 'store-management-push',
    name: 'header.sidebar.store-management-push',
    url: '/store/push',
  },

  // Start Campaigns
  {
    id: 'campaigns',
    name: 'header.sidebar.campaigns.index',
    url: '/campaigns',
  },
  {
    id: 'campaign-campaigns',
    name: 'header.sidebar.campaigns.campaigns',
    url: '/campaigns/campaigns',
  },
  {
    id: 'campaign-messages',
    name: 'header.sidebar.campaigns.messages',
    url: '/campaigns/messages',
  },
  {
    id: 'campaign-attachments',
    name: 'header.sidebar.campaigns.attachments',
    url: '/campaigns/attachments',
  },
  {
    id: 'campaign-engagement',
    name: 'header.sidebar.campaigns.engagement-report',
    url: '/campaigns/campaign-engagement',
  },
  {
    id: 'campaign-sales-report',
    name: 'header.sidebar.campaigns.sales-report',
    url: '/campaigns/campaign-sales-report',
  },
  // End Campaigns

  // New E-Mail menu group
  {
    id: 'email',
    name: 'header.sidebar.email.index',
    url: '/email',
  },
  {
    id: 'email-campaign-list',
    name: 'header.sidebar.email.email-campaign-list',
    url: 'email/campaign-list',
  },
  /*
  {
    id: 'email-results',
    name: 'header.sidebar.email.email-results',
    url: 'email/results',
  },
  {
    id: 'email-deliverability',
    name: 'header.sidebar.email.email-deliverability',
    url: 'email/deliverability',
  },
  */
  // Start SMS
  {
    id: 'sms',
    name: 'header.sidebar.sms.index',
    url: '/sms/campaign-sms',
  },
  {
    id: 'campaign-sms',
    name: 'header.sidebar.sms.campaign',
    url: '/sms/campaign-sms',
  },
  // End SMS

  // Start Base Management
  {
    id: 'base-management',
    name: 'header.sidebar.base-management.index',
    url: '/base-management',
  },
  {
    id: 'base-audiences',
    name: 'header.sidebar.base-audiences',
    url: '/base-management/base-audiences',
  },
  {
    id: 'base-labels',
    name: 'header.sidebar.base-management.labels',
    url: '/base-management/labels',
  },
  {
    id: 'base-personas',
    name: 'header.sidebar.base-management.personas',
    url: '/base-management/personas',
  },
  {
    id: 'audiences-personas-compare',
    name: 'header.sidebar.personas-compare',
    url: '/base-management/personas/compare',
  },
  {
    id: 'base-customers',
    name: 'header.sidebar.base-management.customers',
    url: '/base-management/customers',
  },
  {
    id: 'base-registration-culture',
    name: 'header.sidebar.base-management.base-registration-culture',
    url: '/base-management/registration-culture',
  },
  {
    id: 'customer-distribution',
    name: 'header.sidebar.base-management.customer-distribution',
    url: '/base-management/customer-distribution',
  },
  {
    id: 'rfv',
    name: 'header.sidebar.base-management.rfv',
    url: '/base-management/rfv',
  },
  // End Base Management
  {
    id: 'settings',
    name: 'header.menu.settings',
    url: '/settings',
  },
  // Start Help
  {
    id: 'help',
    name: 'header.sidebar.help.index',
    url: '/help',
  },
  {
    id: 'glossary',
    name: 'header.sidebar.help.glossary',
    url: '/help/glossary',
  },
  {
    id: 'reports',
    name: 'header.sidebar.help.reports',
    url: '/help/reports',
  },
];

/**
 * @description list all user menu options
 */
export const menuUserLogout = {
  id: 'logout',
  name: 'header.menu.logout',
  url: '',
};

/**
 * @description include datepicker just for these routes - urls
 */
export const includeDateRoutes = [
  'base-management/registration-culture',
  'base-management/rfv',
  'cashback/cashback-report',
  'analytics/o2o',
  'analytics/stores',
  'analytics/products',
  'connect/connect-tags',
];

/**
 * @description show datepicker with other settings just for engagement report
 */
export const showDatepickerWithOtherRules = ['campaigns/campaign-engagement'];

/**
 * @description show datepicker with other settings just for sales report new
 */
export const showDatepickerWithCurrentAndFowardDatesDisabled = [
  '/campaigns/campaign-sales-report',
  '/email/email-deliverability',
];

/**
 * @description show datepicker with twelve months + current shortcut for these routes - url
 */
export const showTwelveMonthsPlusCurrentShortcut = ['/campaigns/campaign-sales-report'];

/**
 * @description show datepicker with six months range limit for these routes - url
 * @deprecated Use showEmailCampaignDatepicker instead
 */
export const showSixMonthsRangeLimitRoutes = ['/email/email-deliverability'];

/**
 * @description show custom email campaign datepicker for these routes - url
 */
export const showEmailCampaignDatepicker = ['/email/email-deliverability'];

/**
 * @description exceptionally datepicker is included for these routes - urls
 */
export const exceptionallyIncludeDateRoutes = ['/cashback/cashback-report'];

/**
 * @description add routes url in experimental mode
 */
export const includeExperimentalRoutes = ['websitebehavior'];

/**
 * @description exceptionally show conversion window on header
 */
export const exceptionallyIncludeConversionWindowRoutes = [
  '/campaigns/campaign-sales-report',
  '/campaigns/campaign-engagement',
];

/**
 * @description show date label before datepicker for these routes
 */
export const showDateLabelRoutes = ['/email/email-deliverability'];
